import { ChangeDetectionStrategy, Component, input, output, ViewChild } from "@angular/core";
import { Popover, PopoverModule } from "primeng/popover";

@Component({
  selector: "sxw-overlay-panel",
  templateUrl: "./overlay-panel.component.html",
  styleUrls: ["./overlay-panel.component.scss"],
  imports: [PopoverModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayPanelComponent {
  styleClass = input("");
  appendTo = input<string | HTMLElement | null>("body");

  @ViewChild("popover") popover!: Popover;

  onHide = output<boolean>();
  onShow = output<boolean>();

  overlayPanelStyles = input<Record<string, string>>();

  dt = input<Record<string, unknown>>();

  toggle(event: Event, target?: any) {
    this.popover.toggle(event, target);
  }
}
